var FullCalendar = require('./components/FullCalendar.vue');

module.exports = {
    install: function (Vue, options) {
        Vue.component('full-calendar', FullCalendar);
    },
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-full-calendar/index.js
// module id = 454
// module chunks = 96